const PLURALS = {
  Address: 'Addresses',
  address: 'addresses',
};

export default function pluralize(string) {
  if (string in PLURALS) return PLURALS[string];
  if (string.endsWith('y')) return string.replace(/y$/, 'ies');
  if (!string.endsWith('s')) return `${string}s`;
  return string;
}
